import React from 'react';
import { useIntl } from 'ha/i18n';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import { LoadingButton } from 'ha/components/LoadingButton';

interface Props {
  isLoading?: boolean;
}

const Submit: React.FC<Props> = ({ isLoading = false }) => {
  const { T } = useIntl();

  return (
    <Track name="Clicked Login and continue" type="button">
      <LoadingButton
        loading={isLoading}
        testLocator="Continue login"
        buttonProps={{
          type: 'submit',
          fullWidth: true,
          variant: 'contained',
          color: 'primary',
          size: 'large',
        }}
      >
        {T('Login')}
      </LoadingButton>
    </Track>
  );
};

export { Submit };
